import React from "react";
import { Dialog, Box, Typography, Grid, Button } from "@material-ui/core";
import { DPSpacer } from "Components/DP";

export interface ConfirmActionDialogProps {
  modalText: string;
  confirmButtonText: string;
  quitButtonText: string;
  onClose: () => void;
  onConfirmAction: () => void;
}

export const ConfirmActionDialog = ({
  modalText,
  confirmButtonText,
  quitButtonText,
  onClose,
  onConfirmAction,
}: ConfirmActionDialogProps) => {

  return (
    <Dialog open={true} onClose={onClose}>
      <Box display="flex" flexDirection="column" padding={4}>
        <Typography
          align="center"
        >
          {modalText}
        </Typography>
        <DPSpacer spacing={2} />
        <Grid container justify="center" spacing={2}>
          <Grid item>
            <Button
              color="primary"
              size="large"
              variant="contained"
              onClick={onConfirmAction}
            >
              {confirmButtonText}
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="default"
              onClick={onClose}
              size="large"
              variant="contained"
            >
              {quitButtonText}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};
